import { useTranslation } from 'react-i18next';

export default function LangSwitcher() {
  const { i18n } = useTranslation();
  const langs = [
    { code: 'hu', emoji: 'hu.png', label: 'Magyar' },
    { code: 'en', emoji: 'gb.png', label: 'English' },
    { code: 'de', emoji: 'de.png', label: 'Deutsch' },
  ];

  return (
    <div className="lang-fab" role="group" aria-label="Language selector">
      {langs.map(({ code, emoji, label }) => (
        <button
          key={code}
          onClick={() => i18n.changeLanguage(code)}
          title={label}
          aria-pressed={i18n.language === code}
          className={i18n.language === code ? 'active' : ''}
        >
          <img
            src={emoji}
            alt={label}
            style={{ width: 32, height: 24, borderRadius: 4 }}
          />
        </button>
      ))}
    </div>
  );
}
